export const baseUrl =
  process.env.NODE_ENV === "development" ? "http://localhost:3007" : "/api";

export function buildQuery(query) {
  let queries = Object.keys(query).map((k) => `${k}=${query[k]}`);
  return `?${queries.join("&")}`;
}
